module.exports = __webpack_public_path__ + "static/img/person.b0ee7604.png";